import { render, staticRenderFns } from "./corresponsalia-santader-clonar.vue?vue&type=template&id=6a79f0c5&scoped=true&"
import script from "./corresponsalia-santader-clonar.vue?vue&type=script&lang=js&"
export * from "./corresponsalia-santader-clonar.vue?vue&type=script&lang=js&"
import style0 from "./corresponsalia-santader-clonar.vue?vue&type=style&index=0&id=6a79f0c5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a79f0c5",
  null
  
)

export default component.exports